module.exports = __webpack_public_path__ + "static/img/fusai3.3296605.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fusai3.jpeg
// module id = iqN2
// module chunks = 1